<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
				<v-row class="ma-0 pa-0" align="center" id="header_height">
					<v-col class="ma-0 pa-0" cols="auto">
						<v-btn width="2rem" height="50px" id="back_clean_btn1"
							class="back_clean_btn ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
							@click="goSetting">
							{{ts('title')}}
						</v-btn>
					</v-col>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<v-col class="ma-0 pa-0" cols="auto">{{ts('shareUserPermissionSettings')}}</v-col>
				</v-row>
			</v-col>
		</v-col>

    <v-col class="pa-0" id="main_content_maxwidthset" cols="12" align="center">
			<v-col class="ma-0 pa-0 pt-9 mb-15" cols="10">
        <v-row class="ma-0 pa-0 mb-3" align="center">
          <v-col class="ma-0 pa-0" cols="auto">{{storeName}}</v-col>
        </v-row>
				<v-row class="ma-0 pa-0 mb-7" align="center">
					<v-col class="ma-0 pa-0" cols="auto">
						{{ts('shareMemberList') + ' (' + userTotal.toString() + ')'}}
					</v-col>
					<v-row class="ma-0 pa-0" align="center" justify="end">
						<input id="input_grey" type="text" v-model="searchText"
							ref="searchText" :placeholder="ts('userInputPlaceholder')">
						<v-btn width="4rem" height="2rem" id="blue_btn1"
							class="blue_btn ma-0 pa-0 mr-3" elevation="0" @click="searchUser()">
							{{t('search')}}
						</v-btn>
						<v-btn width="auto" height="2rem" id="blue_btn2"
							class="blue_btn ma-0 pa-0 pl-2 pr-2" elevation="0"
							v-if="authorities.ADD_SHARE_USER"	@click="addShareUserDialogVisible = true">
							{{ts('addShareUserWith')}}
						</v-btn>
					</v-row>
				</v-row>
        <v-row v-if="authorities.SET_PERMISSIONS_GROUP" class="ma-0 pa-0" align="center" justify="end">
          <v-btn :loading="userExportLoading" width="auto" height="2rem" id="btn_user_export"
            class="blue_btn ma-0 pa-0 pl-2 pr-2 mr-3" elevation="0" @click="exportUsers">
            {{ts('userPermissionExport')}}
          </v-btn>
          <v-btn width="auto" height="2rem" id="btn_user_import"
            class="blue_btn ma-0 pa-0 pl-2 pr-2" elevation="0" @click="importUsers">
            {{ts('userPermissionImport')}}
          </v-btn>
        </v-row>

				<!-- 관리자 목록 -->
				<v-col class="ma-0 pa-0 mb-2" cols="12" align="left">
					{{ts('admin')}}
				</v-col>
        <template v-if="areaLoading == false">
          <v-col class="ma-0 pa-0" cols="12" v-if="adminList.length != 0">
				    <v-col class="ma-0 pa-0" cols="12"
					    v-for="(item, index) in searching == false ? adminList : searchAdminList" :key="index">
					    <v-col id="user_box" class="ma-0 pa-3 pl-1 pr-1" cols="12"
				    		:class="{'user_box_top': index == 0 , 
				    			'user_box_bottom': index == (adminList.length -1),
				    			'user_box_border': index != (adminList.length -1)}">
				    		<v-row class="ma-0 pa-0" align="center">
				    			<v-col class="ma-0 pa-0 pl-5 ellipsis" cols="3" align="left">
				    				{{item.name}}
				    			</v-col>
				    			<v-col class="ma-0 pa-0 ellipsis" cols="4" align="left">
				    				{{item.mailAddress}}
				    			</v-col>
				    			<v-col class="ma-0 pa-0" cols="2" style="color:red;">
				    				{{item.userName === '' ? ts('holdFirstRegister') : ''}}
				    			</v-col>
				    			<v-col class="ma-0 pa-0 pr-2" cols="3" align="right">
										<v-row class="ma-0 pa-0" align="center" justify="end">
											<v-btn width="auto" height="2rem" class="blue_btn ma-0 pa-0 mr-2 pl-2 pr-2" 
												v-if="item.userName === ''"
												elevation="0" @click="reSendShareInvite(item)">
												{{ts('resendShare')}}
											</v-btn>
											<UserMoreButton :user="item" :type="'admin'"
												@sendDetailUser="sendDetailUserFunc" @deleteSuccess="deleteSuccessFunc" />
										</v-row>
									</v-col>
				    		</v-row>
				    	</v-col>
				    </v-col>
          </v-col>
          <v-col class="ma-0 pa-0" cols="12" v-else>{{t('noData')}}</v-col>
        </template>
        <template v-else>
          <v-row class="ma-0 pa-0" justify="start">
            <v-col class="ma-0 pa-0" cols="12">
              <v-skeleton-loader style="height:9rem;"	:boilerplate="false" elevation="0" dark
                type="image"></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>

				<!-- 일반 사용자 목록 -->
				<v-col class="ma-0 pa-0 mt-7 mb-2" cols="12" align="left">
					{{ts('normalUser')}}
				</v-col>
        <template v-if="areaLoading == false">
          <v-col class="ma-0 pa-0" cols="12" v-if="normalUserList.length != 0">
				    <v-col class="ma-0 pa-0" cols="12"
				    	v-for="(item, index) in searching == false ? normalUserList : searchNormalUserList" :key="item.email">
				    	<v-col id="user_box" class="ma-0 pa-3 pl-1 pr-1" cols="12"
				    		:class="{'user_box_top': index == 0 , 
				    			'user_box_bottom': index == (normalUserList.length -1),
				    			'user_box_border': index != (normalUserList.length -1)}">
				    		<v-row class="ma-0 pa-0" align="center">
				    			<v-col class="ma-0 pa-0 pl-5 ellipsis" cols="3" align="left">
				    				{{item.name}}
				    			</v-col>
				    			<v-col class="ma-0 pa-0 ellipsis" cols="4" align="left">
				    				{{item.mailAddress}}
				    			</v-col>
				    			<v-col class="ma-0 pa-0" cols="2" style="color:red;">
				    				{{item.userName === '' ? ts('holdFirstRegister') : ''}}
				    			</v-col>
				    			<v-col class="ma-0 pa-0 pr-2" cols="3" align="right">
				    				<v-row class="ma-0 pa-0" align="center" justify="end">
											<v-btn width="auto" height="2rem" class="blue_btn ma-0 pa-0 mr-2 pl-2 pr-2" 
												v-if="item.userName === ''"
												elevation="0" @click="reSendShareInvite(item)">
												{{ts('resendShare')}}
											</v-btn>
											<UserMoreButton :user="item" :type="'normal'"
												@sendUserAuthorityDetail="sendUserAuthorityDetailFunc"
												@deleteSuccess="deleteSuccessFunc" />
										</v-row>
				    			</v-col>
				    		</v-row>
				    	</v-col>
				    </v-col>
          </v-col>
          <v-col class="ma-0 pa-0" cols="12" v-else>
            {{t('noData')}}
          </v-col>
        </template>
        <template v-else>
          <v-row class="ma-0 pa-0" justify="start">
            <v-col class="ma-0 pa-0" cols="12">
              <v-skeleton-loader style="height:9rem;"
						  	:boilerplate="false" elevation="0" dark
                type="image"  
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>

				<!-- 권한 그룹 만들기 -->
				<v-col v-if="authorities.SET_PERMISSIONS_GROUP" id="add_group_divider" class="ma-0 pa-3 mt-5 mb-2 pl-5 pr-0" 
					cols="12" align="left">
          <v-col class="ma-0 pa-0">
            <v-row class="ma-0 pa-0 mb-7" align="center">
              <v-col class="ma-0 pa-0" cols="auto">
                {{ts('privilegeGroupCreation')}}
                <v-btn width="auto" height="auto" id="back_clean_btn2"
                  class="back_clean_btn ma-0 pa-0 ml-2" elevation="0" @click="newPrivilegeGroup">
                  <v-img max-height="1.5rem" max-width="1.5rem" class="ma-0 pa-0"
                    src="@/assets/images/plus_round.png"></v-img>
                </v-btn>
              </v-col>
              <v-row class="ma-0 pa-0" align="center" justify="end">
                <v-row class="ma-0 pa-0" align="center" justify="end">
                  <v-btn :loading="permissionExportLoading" width="auto" height="2rem" id="btn_permission_group_export"
                    class="blue_btn ma-0 pa-0 pl-2 pr-2 mr-3" elevation="0" @click="exportPermissionGruops">
                    {{ts('privilegeGroupExport')}}
                  </v-btn>
                  <v-btn width="auto" height="2rem" id="btn_permission_group_import"
                    class="blue_btn ma-0 pa-0 pl-2 pr-2" elevation="0" @click="importPermissionGroups">
                    {{ts('privilegeGroupImport')}}
                  </v-btn>
                </v-row>
              </v-row>
            </v-row>
          </v-col>
          <template v-if="areaLoading == false && privilegeGroupList.length != 0">
            <v-row v-for="(item, index) in searching == false ? privilegeGroupList : searchPrivilegeGroupList" :key="index" class="ma-0 pa-0 mt-2" id="new_group_result">
              <v-col class="ma-0 pa-3 pl-1 pr-1" id="user_box">
                <v-row class="ma-0 pa-0" align="center" id="auth_group">
                  <v-col class="ma-0 pa-0 pl-5" cols="4" align="left">
				      			{{item.name}}
				      		</v-col>
				      		<v-col class="ma-0 pa-0 pr-2" cols="8" align="right">
                    <v-row class="ma-0 pa-0" justify="end">
                      <v-col class="ma-0 pa-0" cols="auto">
				      			    <v-btn id="transparent_btn" width="auto" height="2rem"
				      			    	class="ma-0 pa-0 pl-2 pr-2" elevation="0" @click="modifyPrivilegeGroup(item)">
				      			    	<v-img src="@/assets/images/icon_setting.png"></v-img>
				      			    </v-btn>
                      </v-col>
                      <v-col class="ma-0 pa-0" cols="auto">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn id="transparent_btn" width="auto" height="2rem"
				      			        	class="ma-0 pa-0 pl-2 pr-2" elevation="0" v-bind="attrs" v-on="on">
				      			        	<v-img src="@/assets/images/dots.png"></v-img>
                            </v-btn>
                          </template>
                          <v-list style="padding:0;font-size:0.8rem;">
                            <v-list-item :ripple="false">
                              <v-list-item-content @click="deletePrivilegeGroup(item)">
                                {{ts('privilegeGroupDelete')}}
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
				      		</v-col>
                </v-row>
              </v-col>
				      <v-col class="ma-0 pa-0" cols="12" style="border-top: 1px solid #707070"
				      	v-for="(item_account, index_account) in item.accountAuthGroupList" :key="index_account">
				      	<v-col id="user_box" class="ma-0 pa-3 pl-1 pr-1" cols="12"
				      		:class="{'user_box_top': index_account == 0 , 
				      			'user_box_bottom': index_account == (item.accountAuthGroupList.length -1),
				      			'user_box_border': index_account != (item.accountAuthGroupList.length -1)}">
				      		<v-row class="ma-0 pa-0" align="center">
				      			<v-col class="ma-0 pa-0 pl-5 ellipsis" cols="3" align="left">
				      				{{item_account.name}}
				      			</v-col>
				      			<v-col class="ma-0 pa-0 ellipsis" cols="4" align="left">
				      				{{item_account.mailAddress}}
				      			</v-col>
										<v-col class="ma-0 pa-0" cols="2" style="color:red;">
											{{item_account.userName === '' ? ts('holdFirstRegister') : ''}}
										</v-col>
										<v-col class="ma-0 pa-0 pr-2" cols="3" align="right">
											<v-row class="ma-0 pa-0" align="center" justify="end">
												<v-btn width="auto" height="2rem" class="blue_btn ma-0 pa-0 mr-2 pl-2 pr-2" 
													v-if="item_account.userName === ''"
													elevation="0" @click="reSendShareInvite(item_account)">
													{{ts('resendShare')}}
												</v-btn>
												<UserMoreButton :user="item_account" :type="'admin'"
												@sendDetailUser="sendDetailUserFunc" @deleteSuccess="deleteSuccessFunc" />
											</v-row>
										</v-col>
				      		</v-row>
				      	</v-col>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="areaLoading == false && privilegeGroupList.length == 0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col class="ma-0 pa-0" cols="12" style="text-align:center">{{t('noData')}}</v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row class="ma-0 pa-0" justify="start">
              <v-col class="ma-0 pa-0 mt-2" cols="12">
                <v-skeleton-loader style="height:9rem;"
				  		  	:boilerplate="false" elevation="0" dark type="image"></v-skeleton-loader>
              </v-col>
            </v-row>
          </template>
				</v-col>

				<!-- 뷰어 목록 -->
				<v-col class="ma-0 pa-0 mt-9 mb-2" cols="12" align="left">
					{{ts('viewer')}}
				</v-col>
        <template v-if="areaLoading == false">
          <v-col class="ma-0 pa-0" cols="12" v-if="viewerList.length != 0">
				    <v-col class="ma-0 pa-0" cols="12"
				    	v-for="(item, index) in searching == false ? viewerList : searchViewerList" :key="item.email">
				    	<v-col id="user_box" class="ma-0 pa-3 pl-1 pr-1" cols="12"
				    		:class="{'user_box_top': index == 0 , 
				    			'user_box_bottom': index == (viewerList.length -1),
				    			'user_box_border': index != (viewerList.length -1)}">
				    		<v-row class="ma-0 pa-0" align="center">
				    			<v-col class="ma-0 pa-0 pl-5 ellipsis" cols="3" align="left">
				    				{{item.name}}
				    			</v-col>
				    			<v-col class="ma-0 pa-0 ellipsis" cols="4" align="left">
				    				{{item.mailAddress}}
				    			</v-col>
									<v-col class="ma-0 pa-0" cols="2" style="color:red;">
				    				{{item.userName === '' ? ts('holdFirstRegister') : ''}}
				    			</v-col>
				    			<v-col class="ma-0 pa-0 pr-2" cols="3" align="right">
				    				<v-row class="ma-0 pa-0" align="center" justify="end">
											<v-btn width="auto" height="2rem" class="blue_btn ma-0 pa-0 mr-2 pl-2 pr-2" 
												v-if="item.userName === ''"
												elevation="0" @click="reSendShareInvite(item)">
												{{ts('resendShare')}}
											</v-btn>
											<UserMoreButton :user="item" :type="'viewer'"
												@sendDetailUser="sendDetailUserFunc"
												@deleteSuccess="deleteSuccessFunc" />
										</v-row>
				    			</v-col>
				    		</v-row>
				    	</v-col>
				    </v-col>
          </v-col>
          <v-col class="ma-0 pa-0" cols="12" v-else>
            {{t('noData')}}
          </v-col>
        </template>
        <template v-else>
          <v-row class="ma-0 pa-0" justify="start">
            <v-col class="ma-0 pa-0" cols="12">
              <v-skeleton-loader style="height:9rem;"
						  	:boilerplate="false" elevation="0" dark
                type="image"  
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>

        <!-- 점포 그룹 설정 -->
        <template v-if="role == 'main' || role == 'head'">
        <!-- <template v-if="authorities.SET_PERMISSIONS_GROUP"> -->
          <v-col class="ma-0 pa-0 mt-9 mb-2" cols="12" align="left">
            <v-row class="ma-0 pa-0 mb-2" align="center">
              <v-col class="ma-0 pa-0" cols="auto">
                {{ts('mappingUserStoreGroup')}}
              </v-col>
              <v-row class="ma-0 pa-0" align="center" justify="end">
                <v-row class="ma-0 pa-0" align="center" justify="end">
                  <v-btn :loading="storeExportLoading" width="auto" height="2rem" id="btn_store_groups_export"
                    class="blue_btn ma-0 pa-0 pl-2 pr-2 mr-3" elevation="0" @click="exportStoreGruops">
                    {{ts('storeGroupExport')}}
                  </v-btn>
                  <!-- 한시적인 버튼 숨김 처리 -->
                  <!-- <v-btn width="auto" height="2rem" id="btn_store_groups_import"
                    class="blue_btn ma-0 pa-0 pl-2 pr-2" elevation="0" @click="importStoreGruops">
                    {{ts('storeGroupImport')}}
                  </v-btn> -->
                </v-row>
              </v-row>
            </v-row>
            <v-col id="user_box" class="ma-0 pa-3 pl-1 pr-1" cols="12">
              <v-row class="ma-0 pa-0" align="center">
                <v-col class="ma-0 pa-0 pl-5" cols="3" align="left">
                  <v-btn width="auto" height="2rem" id="btn_store_groups_import"
                    class="blue_btn ma-0 pa-0 pl-2 pr-2" elevation="0" @click="mappingUserStoreGroup">
                    {{ts('doConfigure')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </template>
				<v-col class="ma-0 pa-0 mt-9 mb-2" cols="12" align="left">
					{{ts('usenTemporaryAccount')}}
				</v-col>
				<v-col id="user_box_alone" class="ma-0 pa-3 pl-1 pr-1" cols="12">
					<v-row class="ma-0 pa-0" align="center" justify="space-between">
						<v-col class="ma-0 pa-0 pl-5" cols="4" align="left">
							{{'USEN' + ts('maintenance')}}
						</v-col>
						<v-row class="ma-0 pa-0" align="center" justify="end">
							<v-col v-if="usenTemporaryUser" class="ma-0 pa-0 mr-3" cols="auto">
								{{ts('enabled')}}
							</v-col>
              <v-col v-else class="ma-0 pa-0 mr-3" cols="auto">
								{{ts('invalid')}}
							</v-col>
							<v-switch class="ma-0 pa-0" v-model="usenTemporaryUser" 
								@click="clickToggle(usenTemporaryUser)"
								hide-details></v-switch>
						</v-row>
					</v-row>
				</v-col>
        <v-col id="user_box_toggle" class="ma-0 pa-3 pl-1 pr-1" cols="12">
					<v-row class="ma-0 pa-0 mb-1" align="center">
						<v-col class="ma-0 pa-0 pl-5" cols="4" align="right">
              {{ts('emailAddressToAllowAccess')}} :
						</v-col>
            <v-col class="ma-0 pa-0 pl-5" cols="auto" align="left">
              <input class="email_input" placeholder="" v-model="tempMailAddress">
            </v-col>
						<v-col class="ma-0 pa-0 pl-3" cols="auto" align="left">
							<v-btn class="blue_btn" id="blue_btn3" style="border-radius:25px;"
								height="1.5rem" @click="maintenanceMailReset">
                {{'初期値に戻す'}}
              </v-btn>
						</v-col>
					</v-row>
          <v-row class="ma-0 pa-0 mb-1" align="center">
						<v-col class="ma-0 pa-0 pl-5" cols="4" align="right">
              {{ts('endDaySetting')}} :
						</v-col>
            <v-col class="ma-0 pa-0 pl-5" cols="4" align="left">
              <input class="date_input" placeholder="" v-model="formatDateValue" readonly>
            </v-col>
            <v-col class="ma-0 pa-0 pl-2" cols="auto" align="left">
							<CustomDatePicker :viewTextField="false" :default90Max="true"
								@resultDate="resultDateFunc" :validPeriod="true" :eventExist="false" />
            </v-col>
					</v-row>
          <v-row class="ma-0 pa-0">
						<v-col class="ma-0 pa-0 pl-5 pt-2" cols="4" align="right">
              {{ts('contentOfCommunication')}} :
						</v-col>
            <v-col class="ma-0 pa-0 pl-5" cols="auto" align="left">
              <textarea class="content_input" placeholder="メンテナンス" v-model="tempMessage"></textarea>
            </v-col>
					</v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="ma-0 pa-0 pr-2" cols="12" align="right">
              <v-btn class="blue_btn" :loading="loading" id="blue_btn3" @click="addMaintenanceUser">
                {{t('send')}}
              </v-btn>
            </v-col>
          </v-row>
				</v-col>
			</v-col>
		</v-col>
		<AddShareUserDialog :dialogVisible="addShareUserDialogVisible" :fromBranchShare="false" 
			:unisCustomerCd="unisCustomerCd" @visible="addShareUserDialogVisibleFunc" />
    <UserDetailDialog :dialogVisible="userDetailDialogVisible" :detailUser="detailUser"
      @visible="userDetailDialogVisibleFunc" />
    <AuthorityGroupDialog :dialogVisible="authorityGroupDialogVisible" :isBranch="false"
      :isUserAuthorityDetail="isUserAuthorityDetail" :userAuthorityDetail="userAuthorityDetail"
      :privilegeGroupList="privilegeGroupList" :privilegeGroupName="privilegeGroupName"
			:privilegeGroupData="privilegeGroupData" :edit="privilegeGroupEdit"
      @visible="authorityGroupDialogVisibleFunc" @showGroupDialog="showGroupDialogResult" 
			@update="authorityGroupUpdateFunc" />
    <DeleteShareGroupDialog :dialogVisible="deleteShareGroupDialogVisible" 
			:deleteGroupId="deleteGroupId"
      @visible="deleteShareGroupDialogVisibleFunc" @isDeleted="isDeletedFunc" />
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import AddShareUserDialog from './authority/addShareUserDialog.vue';
import UserDetailDialog from '@/components/dialogs/UserDetailDialog.vue';
import AuthorityGroupDialog from '@/components/dialogs/AuthorityGroupDialog.vue';
import DeleteShareGroupDialog from '@/components/dialogs/DeleteShareGroupDialog';
import CustomDatePicker from '@/components/DatePicker.vue';
import UserMoreButton from './components/UserMoreButton.vue';
import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import csvProcessor from './authority/csvProcessor';
import { BatchType } from '@/constants';

export default {
	components: {
		AddShareUserDialog, UserDetailDialog, AuthorityGroupDialog, DeleteShareGroupDialog, 
		CustomDatePicker, UserMoreButton
	},
	mixins: [mixin.common],
	data: () => ({
    authorities: {},
    areaLoading: true,
		searchText: '',
		userTotal: 0,
    addShareUserDialogVisible: false,
    userDetailDialogVisible: false,
    authorityGroupDialogVisible: false,
    deleteShareGroupDialogVisible: false,
    detailUser: {},
    isUserAuthorityDetail: false,
    userAuthorityDetail: {},
    dateValue: (new Date(Date.now() + 86400000)).toISOString().substring(0, 10),
		adminList: [],
		normalUserList: [],
		viewerList: [],
		blackList: [],
		usenTemporaryUser: true, //maintenanceActivate
    tempMailAddress: '',
    maintenanceMailAddress: '',
    tempMessage: 'メンテナンス',
    acountAuthGroupList: [], //권한 그룹에 속한 사용자 계정 리스트
    accountList: [], //사용자 계정 상세 정보 리스트
    privilegeGroupList: [], //권한 그룹 정보 리스트 (서버에서 userGroupAuthGroups로 전달됨)
    privilegeGroupName: '',
    privilegeGroupData: {},
    privilegeGroupEdit: 'new',
    deleteGroupId: '',
    groupDeleted: false,
    privateRoleList: ['0', '1', '2', '3', '9'],
    mainRoleList: ['10', '11', '12', '13', '19'],
    headRoleList: ['20', '21', '22', '23', '29'],
    branchRoleList: ['30', '31', '32', '33', '39'],
    userSearchInputValue: null,
    loading: false,
    storeName: '',
		searchAdminList: [],
		searchNormalUserList: [],
		searchViewerList: [],
		searchBlackList: [],
    searchPrivilegeGroupList: [],
    searching: false,
    unisCustomerCd: '',
    userConfig: {},
    role: '',
    userExportLoading: false,
    permissionExportLoading: false,
    storeExportLoading: false,
	}),
	computed: {
		formatDateValue() {
			let date = this.dateValue;
			const year = date.substring(0,4);
			const month = date.substring(5,7);
			const day = date.substring(8,10);
			const time = date.substring(11, 19);
			return year + '年' + month + '月' + day + '日 ' + time;
		}
	},
  created() {
		this.authorities = this.$store.getters.getAuthorities;
    this.storeName = this.$store.getters.getUserDetail.unisCustomerName;
    this.unisCustomerCd = this.$store.getters.getUserDetail.unisCustomerCd;
    this.role = this.roleCheck(this.$store.getters.getRole);
  },
  mounted() {
    this.getShareUserLists();
    this.getUserConfig();
		this.getMaintenanceEmail();
  },
	methods: {
		ts(t) {
      return this.$t("lang.settings." + t);
    },
		goSetting() {
			const role = this.roleCheck(this.$store.getters.getRole);
			if(role == 'private' || role == 'branch') this.replaceRoute('/private/setting', {});
			else this.replaceRoute('/setting', {});
		},
    getUserConfig() {
      const params = {};
      this.networkController.getUserConfig(params).then((res) => {
        this.userConfig = res.data;
        // this.usenTemporaryUser = res.data.maintenanceActivate;
        // this.tempMailAddress = res.data.maintenanceEmail;
        // this.tempMessage = res.data.maintenanceContent;
      }).catch(error => { });
    },
    updateUserConfig() {
      const params = {
        id: this.userConfig.id,
        autoTimeout: this.userConfig.autoTimeout,
        inactiveTimeout: this.userConfig.inactiveTimeout,
        maintenanceActivate: this.usenTemporaryUser,
        maintenanceContent: this.tempMessage,
        maintenanceEmail: this.tempMailAddress,
        umid: this.userConfig.umid,
      };
      this.networkController.updateUserConfig(params).then((res) => {
      }).catch(error => { });
    },
    deleteMaintenanceUser() {
      this.networkController.deleteMaintenanceUser({}).then((res) => {
      }).catch(error => { });
    },
		getMaintenanceEmail() {
			this.networkController.getAccountMaintenanceData({})
			.then((res) => {
				console.log(res.data);
				this.tempMessage = res.data.transmission;
				this.dateValue = res.data.expired.substring(0, 19);
				const mailAddress = res.data.destination == undefined ? '' : res.data.destination;
				this.tempMailAddress = mailAddress;
				this.maintenanceMailAddress = mailAddress;
				if(res.data.destination != undefined) this.toggleUserBox(true);
				else this.getBranchMaintenance();
			}).catch(error => {
				this.toggleUserBox(false);
				this.getBranchMaintenance();
			});
		},
		getBranchMaintenance() {
			this.networkController.getBranchMaintenanceEmailAddress({}, this.unisCustomerCd)
			.then((res) => {
				const mailAddress = res.data.mailAddress == undefined ? '' : res.data.mailAddress;
				this.tempMailAddress = mailAddress;
				this.maintenanceMailAddress = mailAddress;
      }).catch(error => {
				this.toggleUserBox(false);
			});
		},
		maintenanceMailReset() {
			this.networkController.getBranchMaintenanceEmailAddress({}, this.unisCustomerCd)
			.then((res) => {
				const mailAddress = res.data.mailAddress == undefined ? '' : res.data.mailAddress;
				this.tempMailAddress = mailAddress;
      }).catch(error => { });
		},
    clickToggle(item) {
      this.updateUserConfig();
      if(item == false) this.deleteMaintenanceUser();
      this.toggleUserBox(item);
    },
    async getShareUserLists() {
      let params = {};
      this.areaLoading = true;
      this.privilegeGroupList = [];
      this.adminList = [];
      this.normalUserList = [];
      this.viewerList = [];
      this.blackList = [];
      await this.networkController.getShareUserLists(params, this.unisCustomerCd)
      .then(async(res) => {
				console.log('%cAccount Data\n', "color:#008DD0;", res.data);
        this.accountAuthGroupList = res.data.accountAuthGroups === undefined ? [] : res.data.accountAuthGroups;
        this.accountList = res.data.accounts === undefined ? [] : res.data.accounts;
        this.userTotal = 0;
        let role = this.roleCheck(this.$store.getters.getRole);
        if(role == "private") {
          res.data.userGroupAuthGroups.forEach((item) => {
            if(this.privateRoleList.indexOf(item.accountRole) != -1){
              this.privilegeGroupList.push(item);
            }
          });
          this.accountList.forEach((item) => {
            if(this.privateRoleList.indexOf(item.role) != -1){
              this.userTotal += 1;
            }
          });
        } else if(role == "main") {
          res.data.userGroupAuthGroups.forEach((item) => {
            if(this.mainRoleList.indexOf(item.accountRole) != -1){
              this.privilegeGroupList.push(item);
            }
          });
          this.accountList.forEach((item) => {
            if(this.mainRoleList.indexOf(item.role) != -1){
              this.userTotal += 1;
            }
          });
        } else if(role == "head") {
          res.data.userGroupAuthGroups.forEach((item) => {
            if(this.headRoleList.indexOf(item.accountRole) != -1){
              this.privilegeGroupList.push(item);
            }
          })
          this.accountList.forEach((item) => {
            if(this.headRoleList.indexOf(item.role) != -1){
              this.userTotal += 1;
            }
          })
        } else {
          res.data.userGroupAuthGroups.forEach((item) => {
            if(this.branchRoleList.indexOf(item.accountRole) != -1){
              this.privilegeGroupList.push(item);
            }
          });
          this.accountList.forEach((item) => {
            if(this.branchRoleList.indexOf(item.role) != -1){
              this.userTotal += 1;
            }
          });
        }
        
        //권한 그룹(userGroupAuthGroups == privilegeGroupList)에 포함된 사용자 찾기
        if(this.privilegeGroupList.length != 0) {
          this.privilegeGroupList.forEach((item) => {
            let groupId = item.id;

            //권한 그룹에 속한 사용자가 있는 경우
            if(this.accountAuthGroupList.length !=0) {
              let accountInGroup = []; //같은 그룹인 사용자들을 넣을 리스트
              for(let i=0; i<this.accountAuthGroupList.length; i++) {
                if(this.accountAuthGroupList[i].userGroupAuthGroupId === groupId) { 
                  //그룹에 포함되어 있는 사용자의 umid 구하기
                  let umid = this.accountAuthGroupList[i].umid;
                  //accountList에서 umid가 같은 사용자 데이터 가져오기
                  let index = this.accountList.findIndex(r => r.umid == umid);
                  //리스트에 저장
                  if(index != -1){
                    if(this.accountList[index].status != "0")
                      accountInGroup.push(this.accountList[index]);
                    else 
                      this.blackList.push(this.accountList[index]);
                  }
                }
              }
              //그룹에 넣기
              item['accountAuthGroupList'] = accountInGroup;
            } else {
              item['accountAuthGroupList'] = [];
              console.log("privilegeGroupList is empty");
            }

            //권한 그룹에 포함된 사용자를 accountList에서 제거
            for(let i=0; i<item.accountAuthGroupList.length; i++) {
              let index = this.accountList.findIndex(r => r.umid == item.accountAuthGroupList[i].umid);
              if(index != -1) {
                this.accountList.splice(index, 1);
              }
            }
          });
        }

        //권한 그룹에 포함되지 않은 사용자들 권한별로 나누기
        if(role == "private") {
          this.accountList.forEach((item) => {
            //status가 0인 경우 blackList에 저장 (status 0 == 정지중 status 1 == 작동중)
            if(item.status == "0" && this.privateRoleList.indexOf(item.role) != -1) {
              this.blackList.push(item);
            }
            else {
              if(item.role == "1") {
                this.adminList.push(item);
              }
              else if(item.role == "2") {
                this.normalUserList.push(item);
              }
              else if(item.role == "3"){
                this.viewerList.push(item);
              }
            }
          });
        }
        else if(role == "main") {
          this.accountList.forEach((item) => {
            //status가 0인 경우 blackList에 저장
            if(item.status == "0" && this.mainRoleList.indexOf(item.role) != -1) {
              this.blackList.push(item);
            }
            else {
              if(item.role == "11") {
                this.adminList.push(item);
              }
              else if(item.role == "12") {
                this.normalUserList.push(item);
              }
              else if(item.role == "13"){
                this.viewerList.push(item);
              }
            }
          });
        }
        else if(role == "head") {
          this.accountList.forEach((item) => {
            //status가 0인 경우 blackList에 저장
            if(item.status == "0" && this.headRoleList.indexOf(item.role) != -1) {
              this.blackList.push(item);
            }
            else {
              if(item.role == "21") {
                this.adminList.push(item);
              }
              else if(item.role == "22") {
                this.normalUserList.push(item);
              }
              else if(item.role == "23"){
                this.viewerList.push(item);
              }
            }
          });
        }
        else { //branch role
          this.accountList.forEach((item) => {
            //status가 0인 경우 blackList에 저장
            if(item.status == "0" && this.branchRoleList.indexOf(item.role) != -1) {
              this.blackList.push(item);
            }
            else {
              if(item.role == "31") {
                this.adminList.push(item);
              }
              else if(item.role == "32") {
                this.normalUserList.push(item);
              }
              else if(item.role == "33"){
                this.viewerList.push(item);
              }
            }
          });
        }
				console.log('adminList\n', this.adminList);
				console.log('normalUserList\n', this.normalUserList);
				console.log('viewerList\n', this.viewerList);
        this.areaLoading = false;
      }).catch(error => {
        this.areaLoading = false;
      });
    },
		reSendShareInvite(account) {
			this.$vloading.show();
			this.networkController.shareUserReInvite({}, account.umid)
			.then((res) => {
				this.showToastMessage(this.tmb('requestSuccess'));
				this.$vloading.hide();
      }).catch(error => {
				this.showToastMessage(this.tmb('requestFail'));
				this.$vloading.hide();
			});
		},
    async addMaintenanceUser() {
			if(this.validateEmail(this.tempMailAddress) == false || this.tempMailAddress == '') {
				this.showToastMessage(this.tmb('notEmailFormat'));
				return;
			}
      this.loading = true;
      let params = {
        transmission: this.tempMessage == '' ? 'メンテナンス' : this.tempMessage,
        destination: this.tempMailAddress,
        expired: this.dateValue.replace('.000Z', '+09:00'),
      };
      await this.networkController.addMaintenanceUser(params)
      .then(async(res) => {
        this.updateUserConfig();
				this.showToastMessage(this.tmb('requestSuccess'));
        this.loading = false;
      }).catch(error => {
				this.showToastMessage(this.tmb('requestFail'));
        this.loading = false;
      });
    },
    newPrivilegeGroup() {
      this.isUserAuthorityDetail = false;
      this.authorityGroupDialogVisible = true;
      this.privilegeGroupEdit = 'new';
    },
    modifyPrivilegeGroup(item) {
      this.privilegeGroupEdit = 'modify';
      this.privilegeGroupName = item.name;
      let index = this.privilegeGroupList.findIndex(r => r.id == item.id);
      if(index != -1) {
        this.privilegeGroupData = this.privilegeGroupList[index];
      }
      this.isUserAuthorityDetail = false;
      this.authorityGroupDialogVisible = true;
    },
    deletePrivilegeGroup(item) {
      this.deleteGroupId = item.id;
      this.deleteShareGroupDialogVisible = true;
    },
		sendDetailUserFunc(detail) {
			this.detailUser = detail;
			this.userDetailDialogVisible = true;
		},
		sendUserAuthorityDetailFunc(detail) {
      console.log(detail)
      this.privilegeGroupEdit = 'modify';
			this.userAuthorityDetail = detail;
    	this.isUserAuthorityDetail = true;
			this.authorityGroupDialogVisible = true;
		},
		deleteSuccessFunc(status) {
			if(status) this.getShareUserLists();
		},
    showMaintainerDetail(item) {
			this.$vloading.show();
      let params = {};
      this.networkController.getShareUserByUmid(params, item.umid)
      .then((res) => {
				console.log(res.data);
        this.detailUser = item;
        this.detailUser.status = res.data.accounts[0].status;
        this.detailUser.userLoginId = res.data.accounts[0].userName;
        this.userDetailDialogVisible = true;
        this.$vloading.hide();
      }).catch(error => { this.$vloading.hide(); });
    },
    showUserSettingDetail(item) {
			// console.log(item);
			this.$vloading.show();
      let params = {};
      this.networkController.getShareUserByUmid(params, item.umid)
      .then((res) => {
        this.authorityGroupDialogVisible = true;
        this.isUserAuthorityDetail = true;
        this.userAuthorityDetail = item;
        this.userAuthorityDetail.status = res.data.accounts[0].status;
        this.userAuthorityDetail.userLoginId = res.data.accounts[0].userName;
        this.$vloading.hide();
      }).catch(error => { this.$vloading.hide(); });
      // this.detailUser = item;
    },
    showUserDetail(item) {
			// console.log(item);
			this.$vloading.show();
			let params = {};
			this.networkController.getShareUserByUmid(params, item.umid)
			.then((res) => {
				console.log(res.data);
				this.detailUser = item;
        this.detailUser.userLoginId = res.data.accounts.length !== 0 ? res.data.accounts[0].userName : '';
				this.userDetailDialogVisible = true;
        this.$vloading.hide();
			}).catch(error => { this.$vloading.hide(); });
    },
    toggleUserBox(value) {
      if(value) {
        $('#user_box_toggle').css({'display':'block'});
				this.usenTemporaryUser = true;
      } else {
        $('#user_box_toggle').css({'display':'none'});
        this.usenTemporaryUser = false;
      }
    },
    showChangeUserAuth(item) {
			this.$vloading.show();
      let params = {};
      this.networkController.getShareUserByUmid(params, item.umid)
      .then((res) => {
        this.detailUser = item;
        this.detailUser.userLoginId = res.data.accounts[0].userName === undefined ? '' : res.data.accounts[0].userName;
        this.userDetailDialogVisible = true;
        this.$vloading.hide();
      }).catch(error => { this.$vloading.hide(); });
    },
    showGroupDialogResult(showGroupDialog) {
      if(showGroupDialog === true) {
        console.log("groupdialog0");
        this.authorityGroupDialogVisible = false;
        $('#new_group_result').css({'display':'block'});
      }
    },
    addShareUserDialogVisibleFunc(visible) {
      this.addShareUserDialogVisible = visible;
      if(visible === false) {
        this.getShareUserLists();
      }
    },
		userDetailDialogVisibleFunc(visible) {
      this.userDetailDialogVisible = visible;
    },
    authorityGroupDialogVisibleFunc(visible) {
      this.authorityGroupDialogVisible = visible;
      if(visible === false) {
        this.isUserAuthorityDetail = false;
				this.privilegeGroupData = {};
        this.userAuthorityDetail = undefined;
      }
    },
    authorityGroupUpdateFunc(status) {
      if(status) {
        this.showToastMessage(this.tmb('requestSuccess'));
        this.getShareUserLists();
      }
    },
    deleteShareGroupDialogVisibleFunc(visible) {
      this.deleteShareGroupDialogVisible = visible;
    },
    isDeletedFunc(isDeleted) {
      if(this.deleteShareGroupDialogVisible == false) {
        if(isDeleted == true){
          this.getShareUserLists();
        }
      }
    },
		resultDateFunc(date) {
			this.dateValue = date;
		},
    searchUser() { //검색 기능
      this.areaLoading = true;
      setTimeout(() => {
        //데이터 observer 제거
        const adminData = JSON.parse(JSON.stringify(this.adminList));
        this.searchAdminList = adminData;
        const normalUserData = JSON.parse(JSON.stringify(this.normalUserList));
        this.searchNormalUserList = normalUserData;
        const viewerData = JSON.parse(JSON.stringify(this.viewerList));
        this.searchViewerList = viewerData;
        const blackData = JSON.parse(JSON.stringify(this.blackList));
        this.searchBlackList = blackData;
        const privilegeData = JSON.parse(JSON.stringify(this.privilegeGroupList));
        this.searchPrivilegeGroupList = privilegeData;

        this.areaLoading = true;
        this.searching = true;
        let search = this.searchText;

        if(this.searchAdminList.length != 0) {
          this.searchAdminList.reduceRight(function(acc, item, index, object) {
            if(item.mailAddress.indexOf(search) == -1 && item.name.indexOf(search) == -1) {
              object.splice(index, 1);
            }
          }, []);
        }
        if(this.searchNormalUserList.length != 0) {
          this.searchNormalUserList.reduceRight(function(acc, item, index, object) {
            if(item.mailAddress.indexOf(search) == -1 && item.name.indexOf(search) == -1) {
              object.splice(index, 1);
            } 
          }, []);
        }
        if(this.searchViewerList.length != 0) {
          this.searchViewerList.reduceRight(function(acc, item, index, object) {
            if(item.mailAddress.indexOf(search) == -1 && item.name.indexOf(search) == -1) {
              object.splice(index, 1);
            }
          }, []);
        }
        if(this.searchBlackList.length != 0) {
          this.searchBlackList.reduceRight(function(acc, item, index, object) {
            if(item.mailAddress.indexOf(search) == -1 && item.name.indexOf(search) == -1) {
              object.splice(index, 1);
            }
          }, []);
        }
        this.searchPrivilegeGroupList.forEach((data) => {
          if(data.accountAuthGroupList.length != -1) {
            data.accountAuthGroupList.reduceRight(function(acc, item, index, object) {
              if(item.mailAddress.indexOf(search) == -1 && item.name.indexOf(search) == -1) {
                object.splice(index, 1);
              }
            }, []);
          }
        });
      this.areaLoading = false;
      }, 500);
    },
    async exportUsers() {
      this.userExportLoading = true;
      const res = await this.networkController.getBatchAccountAuthGroup({}); //사용자 권한 그룹 정보 가져오기
      csvProcessor.exportCSV(res.data, BatchType.USER_AUTHORITY, this.role);
      this.userExportLoading = false;
    },
    importUsers() {
      this.pushRoute('/setting/authority/register-csv', {
        type: BatchType.USER_AUTHORITY
      });
    },
    async exportPermissionGruops() {
      this.permissionExportLoading = true;
      const res = await this.networkController.getBatchUserGroupAuthGroup({}); //사용자 권한 그룹 정보 가져오기
      csvProcessor.exportCSV(res.data, BatchType.USER_GROUP, this.role);
      this.permissionExportLoading = false;
    },
    importPermissionGroups() {
      this.pushRoute('/setting/authority/register-csv', {
        type: BatchType.USER_GROUP
      });
    },
    async exportStoreGruops() {
      this.storeExportLoading = true;
      const res = await this.networkController.getBatchSharedUserStoreGroup({});
      csvProcessor.exportCSV(res.data, BatchType.STORE_GROUP, this.role);
      this.storeExportLoading = false;
    },
    importStoreGruops() {
      this.pushRoute('/setting/authority/register-csv', {
        type: BatchType.STORE_GROUP
      });
    },
    mappingUserStoreGroup() {
      this.pushRoute('/setting/authority/mapping-user-groups', {});
    },
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	background-color: #272A33;
	position: sticky;
	top: 0;
	z-index: 5;
}
#header_height {
	height: 50px;
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem !important;
	color: white;
}
.blue_btn {
	background-color: #008DD0 !important;
	color: white;
	border-radius: 4px;
	min-width: 1rem !important;
}
.white_btn {
	background-color: white !important;
  border-radius: 4px;
	min-width: 1rem !important;
	color: black;
}
#input_grey {
	width: 17rem;
}
#user_box {
	background-color: #383838;
}
.user_box_top {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}
.user_box_bottom {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}
.user_box_border {
	border-bottom: 1px solid #707070;
}
#user_box_alone {
	background-color: #383838;
	border-radius: 4px;
}
#user_box_toggle {
	background-color: #383838;
	border-radius: 4px;
  display: none;
}
#add_group_divider {
	border-left: 2px solid #656565;
}
.user_detail_list {
  height: 3rem;
  align-content: center;
  border-bottom: 1px solid #707070;
}
.status_select {
  font-size: 0.8em;
}
.v-list {
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    /* padding: 0px 0; */
    color: white;
  }
  .v-list-item--active .v-list-item__content {
    color: white;
  }
  .v-list-item__icon.v-list-group__header__prepend-icon {
    color: white;
  }
}
.user_detail_group {
  color: #8B8B8B;
}
// #new_group_result {
//   display: none;
// }
input, textarea {
  padding-left: 10px;
  color: white;
  background-color: #272727;
  border: 1px solid #4A4A4A;
  border-radius: 3px;
  height: 2.5em;
}
.name_input {
  width: 15em;
}
.email_input {
  width: 25em;
}
.date_input {
  width: 100%;
}
.content_input {
	padding-top: 7px;
	padding-bottom: 7px;
	padding-right: 10px;
  width: 25em;
  min-height: 5em;
  max-height: 5em;
}
.content_input::placeholder{
  font-size: 1rem;
}
.btn_cancel {
  width: 12em;
  margin-right: 5px;
}
.btn_yes {
  width: 12em;
}
#transparent_btn {
  background-color: transparent;
  max-width: 3em;
  min-width: 3em;
}
</style>